import { reactive, computed } from '@vue/composition-api'
import { addHyphenForZipcode } from '@/util/common'

export const Contract = (context) => {

  const state = reactive({
    visibleNoteBreakdown: false
  })

  // contextからstore取り出し
  const store = context.root.$store
  const { contract } = store.state

  // APIでデータを取得してストアに保存
  store.dispatch('contract/getContractData')

  // 郵便番号のハイフン付け
  const postnumberAddHyphen = computed(() => {
    return addHyphenForZipcode(contract.postnumber)
  })

  const isAgreement = computed(() => store.getters['contract/isAgreement'])

  // 住所の文字列結合
  const addressUnion = computed(() => {
    const { address, address2, address3 } = contract
    let addressTmp = ''
    if (address) addressTmp += address
    if (address2) addressTmp += address2
    if (address3) addressTmp += address3
    return addressTmp
  })

  return {
    state,
    contract,
    isAgreement,
    postnumberAddHyphen,
    addressUnion
  }
}
